import { render, staticRenderFns } from "./empty-list.vue?vue&type=template&id=5577b174&scoped=true&"
import script from "./empty-list.vue?vue&type=script&lang=js&"
export * from "./empty-list.vue?vue&type=script&lang=js&"
import style0 from "./empty-list.vue?vue&type=style&index=0&id=5577b174&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5577b174",
  null
  
)

export default component.exports